import ScrollMagic from 'scrollmagic';
import { createMoveTween } from '../scroll-animations';

export default ({sceneConfig, tweenConfig}, controller) => {
  const animations = {
    move: createMoveTween
  };

  const tween = animations[tweenConfig.type](tweenConfig);

  if (tween) {
    controller.addScene(
        new ScrollMagic.Scene(sceneConfig)
            .setTween(tween)
    );
  }
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/scroll-animations/common.js